import { Box, Button, makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  box: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-between",
    },
  },
  but: {
    width: "100px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

export default function BaseOption({ children, butProps, hideEdit, ...props }) {
  const cls = useStyle();

  return (
    <Box {...props}>
      {children}
      <Box className={cls.box} mt={1}>
        {!hideEdit && (
          <Button variant="outlined" color="primary" className={cls.but} {...butProps}>
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );
}
